export const DOC_CONTROL_REF = 'DOC_CONTROL_REF';